import Button from "presentation/components/Button/Button";
import styles from "../FooterLinks/FooterLink.module.scss";
import { useNavigate } from "react-router-dom";

const CookiePolicy = () => {

  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center align-items-center w-100">
      <div className={`${styles.popup} px-5 py-4 mb-2`}>
        <h1>Cookie Policy</h1>
        <p>Our website uses cookies to distinguish you from other users of our website. This helps us provide you with a good experience when you browse our website and also allows us to improve our website. By continuing to browse the website, you are agreeing to our use of cookies.</p>
        <h2>How this website uses cookies</h2>
        <h3>What is a cookie?</h3>
        <p>A cookie is a small file of letters and numbers that we store on your browser or the hard drive of your computer. Cookies contain information that is transferred to your computer's hard drive, these cookies do not contain any identifiable pieces of information.</p>
        <h2>What we use cookies for:</h2>
        <h3>1. Improving our website</h3>
        <p>For statistical purposes only, we track how many individual unique users we receive and how often they visit our website. We collect anonymous data which tells us which of our pages are most frequently visited and by which types of users and from which countries. This allows us to see which content is more popular than others. In order to do this, we use a web analytics tool called Google Analytics.</p>
        <h3>2. Ensuring our online advertising is targeted and relevant</h3>
        <p>From time to time we may engage in advertising on other websites to promote this website. The advertising partners we use may serve ads that it believes are most likely to be of interest to you, based on information about your visit to this and other websites (this information is anonymous in that it does not include your name, street address, email address or telephone number).</p>
        <p>In order to do this, our advertising partner may need to place a cookie on your computer. Furthermore, in order to identify that you are part of the relevant target audience, they may identify that you have previously visited this website by using a cookie dropped from this website (this is called re-targeting).</p>
        <p>These advertising cookies are typically referred to as 'third party cookies' because the advertising and tracking are carried out by a 'third party'.</p>
        <p>For more information about this type of online behavioural advertising, about cookies, and about how to turn this feature off, please visit www.youronlinechoices.co.uk.</p>
        <h2>What cookies we use: </h2>
        <ul>
          <li><strong>Analytical/performance cookies :</strong> <>they allow us to recognise and count the number of visitors and to see how visitors move around our website when they are using it. This helps us to improve the way our website works, for example, by ensuring that users are finding what they are looking for easily. </></li>
        </ul>
        <p>You can find more information about the individual cookies we use and the purposes for which we use them in the table below:</p>

        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr className={styles.header}>
                <th>Cookie Name</th>
                <th>Type</th>
                <th>Expiry</th>
                <th>Third Party</th>
                <th>Purpose</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>BIGipServer#</td>
                <td>HTTP</td>
                <td>Session</td>
                <td>N/A</td>
                <td>Used to distribute traffic to the website on several servers in order to optimise response times.</td>
              </tr>
              <tr>
                <td>__utm.gif</td>
                <td>Pixel</td>
                <td>Session</td>
                <td>Google Analytics</td>
                <td>Google Analytics Tracking Code that logs details about the visitor's browser and computer.</td>
              </tr>
              <tr>
                <td>__utma</td>
                <td>HTTP</td>
                <td>2 years</td>
                <td>Google Analytics</td>
                <td>Collects data on the number of times a user has visited the website as well as dates for the first and most recent visit. Used by Google Analytics.</td>
              </tr>
              <tr>
                <td>__utmb</td>
                <td>HTTP</td>
                <td>1 day</td>
                <td>Google Analytics</td>
                <td>Registers a timestamp with the exact time of when the user accessed the website. Used by Google Analytics to calculate the duration of a website visit.</td>
              </tr>
              <tr>
                <td>__utmc</td>
                <td>HTTP</td>
                <td>Session</td>
                <td>Google Analytics</td>
                <td>Registers a timestamp with the exact time of when the user leaves the website. Used by Google Analytics to calculate the duration of a website visit.</td>
              </tr>
              <tr>
                <td>__utmt</td>
                <td>HTTP</td>
                <td>1 day</td>
                <td>Google Analytics</td>
                <td>Used to throttle the speed of requests to the server</td>
              </tr>
              <tr>
                <td>__utmz</td>
                <td>HTTP</td>
                <td>6 months</td>
                <td>Google Analytics</td>
                <td>Collects data on where the user came from, what search engine was used, what link was clicked and what search term was used. Used by Google Analytics.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2>How can you manage your cookies?</h2>
        <h3>Browser settings</h3>
        <p>Most browsers can be altered to prevent your computer from accepting cookies, although this may mean that some of the features of this website (and other websites) will not work properly and may restrict your user experience.</p>
        <p>These settings will typically be found in the 'options' or 'preferences' menu of your browser. In order to understand these settings, the following links may be helpful; otherwise you should use the 'Help' option in your browser for more details.</p>
        <p><a href="https://support.microsoft.com/en-gb/kb/196955" target="_blank" rel="noopener noreferrer">Cookie settings in Internet Explorer</a></p>
        <p><a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies" target="_blank" rel="noopener noreferrer">Cookie settings in Firefox</a></p>
        <p><a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank" rel="noopener noreferrer">Cookie settings in Chrome</a></p>
        <h3>Turn off anonymous Google Analytics cookies</h3>
        <p>You can install a Google Analytics browser 'plug in' to prevent the website sending information about your visit to Google Analytics. More information about this can be found below.</p>
        <p><a href="https://www.google.com/intl/en/analytics/privacyoverview.html" target="_blank" rel="noopener noreferrer">Google Analytics and Privacy</a></p>
        <h3>Turn off third party cookies</h3>
        <p>In order to prevent third party cookies from being dropped onto your browser, you can go to the relevant third party website and generate a one-time 'no thanks' cookie. This will stop any further cookies being served to your browser from this third party. The third party used by this website is DoubleClick and you can find out instructions on how to do this on the link below.</p>
        <p><a href="https://www.google.com/privacy_ads.html" target="_blank" rel="noopener noreferrer">DoubleClick</a> (owned by Google)</p>
        <p>If you would like to find out more about cookies and their wider use, you may find the following links of interest:</p>
        <p><a href="https://www.microsoft.com/info/cookies.mspx" target="_blank" rel="noopener noreferrer">Microsoft Cookies guide</a></p>
        <p><a href="https://www.aboutcookies.org/" target="_blank" rel="noopener noreferrer">All About Cookies</a></p>
        <p>The IAB (Internet Advertising Bureau) has provided the following website to give information specifically about privacy issues around internet advertising:</p>
        <p><a href="https://www.youronlinechoices.com/uk/" target="_blank" rel="noopener noreferrer">youronlinechoices.co.uk/uk</a></p>
        <p>For further legal information about privacy issues, you may find these links useful:</p>
        <p><a href="https://ico.org.uk/" target="_blank" rel="noopener noreferrer">The Information Commissioner's Office</a></p>
        <div className={styles.info}>This website contains material including text, photographs and graphics, which is protected by intellectual property rights. All rights in this material are either owned by epyx or have been licensed to epyx by the owner(s) of those rights. 1link may only be accessed by authorised users. Unauthorised access is forbidden. The 1link name and the 1link platform are registered trademarks of epyx Limited.</div>
        <div className={`${styles.close} float-end mt-3`}>
          <Button label="OK" onClick={() => navigate("/")} />
        </div>
      </div>
    </div >
  )
}

export default CookiePolicy;